<template>
  <dl>
    <dt :style="{ minWidth: labelWidth }" :class="{ required }">{{ label }}</dt>
    <dd :style="{ marginLeft }">
      <div style="display: inline-grid">
        <el-tooltip effect="dark" :content="tips" :disabled="!tips" placement="top-start">
          <div class="text-ellipsis">
            <slot />
          </div>
        </el-tooltip>
      </div>
    </dd>
  </dl>
</template>

<script>
  export default {
    name: 'mgItem',
    props: {
      required: Boolean,
      tips: String,
      label: String,
      labelWidth: {
        type: String,
        default: '80px',
      },
      marginLeft: String,
    },
  }
</script>

<style lang="scss" scoped>
  dl {
    display: flex;
    align-items: baseline;
    margin-block-start: 0;
    margin-block-end: 0;
    dt {
      font-family: PingFang SC, -apple-system, BlinkMacSystemFont, Helvetica Neue, Helvetica, Arial, Hiragino Sans GB,
        Microsoft Yahei, STHeiti, SimSun, sans-serifsans-serif;
      text-align: right;
      color: #252a3d;
      &.required {
        &::before {
          content: '*';
          color: red;
          margin-right: 3px;
        }
      }
    }
    dd {
      margin-left: 12px;
      .text-ellipsis {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }
    }
  }
</style>
